import { metricKeys } from '@pulse/metrics';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

// Quality metrics(key) to Audience metrics(value) Mapping.
export const METRICS_MAPPING = {
  APP: {
    // config comes from this doc
    // https://conviva.atlassian.net/wiki/spaces/DSMM/pages/1767243841/Out-of-the-box+metrics+for+App+Insights+Beta
    AppAvgScreenLoadTime: metricKeys.AppScreenLoads,
    AppAvgPageLoadTime: metricKeys.AppPageLoadComplete,
    AppErrors: metricKeys.AppSessions,
    AverageMinutesPerPage: metricKeys.AppPageLoads,
    AppVideoBounceRate: metricKeys.EndedSessionCount,
    TimeToFirstAttempt: metricKeys.AppSessions,
    AppStartupTime: metricKeys.AppStartupCount,
    AppCrashSessions: metricKeys.AppSessions,
    AverageRequestDuration: metricKeys.AverageRequestCount,
    FailedNetworkRequest: metricKeys.AverageRequestCount,
    EndedSessionCountMobile: metricKeys.EndedSessionCount,
    EndedSessionCountWeb: metricKeys.EndedSessionCount,

    // App SPI
    AppServicePerformanceIndex: metricKeys.AppSPIImpactedSession,
    AppSPIImpactedSession: metricKeys.AppUniqueDevices,
    AppSPIImpactedSessionRate: metricKeys.AppUniqueDevices,
    AppSPIHighScreenLoadRate: metricKeys.AppUniqueDevices,
    AppSPIHighScreenLoadCount: metricKeys.AppUniqueDevices,
    AppSPIHighPageLoadRate: metricKeys.AppUniqueDevices,
    AppSPIHighPageLoadCount: metricKeys.AppUniqueDevices,
    AppSPIHighAppStartupRate: metricKeys.AppUniqueDevices,
    AppSPIHighAppStartupCount: metricKeys.AppUniqueDevices,
    AppSPIAppCrashSessionRate: metricKeys.AppUniqueDevices,
    AppSPIAppCrashSessionCount: metricKeys.AppUniqueDevices,
  },
  EI: {
    VideoStartFailures: metricKeys.Attempts,
    VideoStartFailuresPercentage: metricKeys.Attempts,
    ExitBeforeVideoStarts: metricKeys.Attempts,
    ExitBeforeVideoStartsPercentage: metricKeys.Attempts,
    RebufferingRatio: metricKeys.Plays,
    ConnectionInducedRebufferingRatio: metricKeys.Plays,
    ZeroCIRREndedPlays: metricKeys.EndedPlays,
    ZeroCIRREndedPlaysPct: metricKeys.EndedPlays,
    NonZeroCIRREndedPlays: metricKeys.EndedPlays,
    LifePausedTimePct: metricKeys.EndedPlays,
    LifePausedTimeMins: metricKeys.EndedPlays,
    LifeAvgNumBitrateSwitches: metricKeys.EndedPlays,
    AvgBitrate: metricKeys.EndedPlays,
    LifeJoinedAvgBitrate: metricKeys.EndedPlays,
    NonZeroCIRREndedPlaysPct: metricKeys.EndedPlays,
    VideoPlaybackFailures: metricKeys.EndedPlays,
    VideoPlaybackFailuresPercentage: metricKeys.EndedPlays,
    VideoStartTime: metricKeys.Plays,
    VideoRestartTime: metricKeys.EndedPlays,
    Bitrate: metricKeys.Plays,
    Framerate: metricKeys.Plays,
    PlaysPercentage: metricKeys.Attempts,
    VideoStartFailuresBusiness: metricKeys.Attempts,
    VideoStartFailuresBusinessPercentage: metricKeys.Attempts,
    VideoPlaybackFailuresBusiness: metricKeys.EndedPlays,
    VideoPlaybackFailuresBusinessPercentage: metricKeys.EndedPlays,
    VideoStartFailuresTech: metricKeys.Attempts,
    VideoStartFailuresTechPercentage: metricKeys.Attempts,
    VideoPlaybackFailuresTech: metricKeys.EndedPlays,
    VideoPlaybackFailuresTechPercentage: metricKeys.EndedPlays,
    HighExitBeforeVideoStart: metricKeys.Attempts,
    HighExitBeforeVideoStartPercentage: metricKeys.Attempts,
    SpiStreams: metricKeys.Attempts,
    StreamingPerformanceIndex: metricKeys.SpiStreams,
    BadSession: metricKeys.SpiStreams,
    HighRebufferingPercentage: metricKeys.EndedPlays,
    HighRebuffering: metricKeys.EndedPlays,
    HighStartupTimePercentage: metricKeys.Plays,
    HighStartupTime: metricKeys.Plays,
    LowBitratePercentage: metricKeys.EndedPlays,
    LowBitrate: metricKeys.EndedPlays,
    MinutesPlayed: metricKeys.EndedPlays,
    ExitDueToCIR: metricKeys.EndedPlays,
    MinutesPlayedPerEndedPlay: metricKeys.EndedPlays,
    MinutesPlayedPerUniqueDevice: metricKeys.UniqueDevices,
    LifeDropFrameRatio: metricKeys.EndedPlays,
    // Pre-Roll metrics
    ExitsDuringPreRoll: metricKeys.Attempts,
    ExitsDuringPreRollPct: metricKeys.Attempts,
    AdRelatedBufferingRatio: metricKeys.Plays,
    RebufferingDuringAdsRatio: metricKeys.Plays,
    // Ad Content Metrics
    AdPlaysPercentage: metricKeys.AdAttempts,
    AdBitrate: metricKeys.AdPlays,
    AdEndedPlaysPerUniqueDevice: metricKeys.AdPlays,
    AdExitBeforeVideoStarts: metricKeys.AdAttempts,
    AdExitBeforeVideoStartsPercentage: metricKeys.AdAttempts,
    AdRebufferingRatio: metricKeys.AdPlays,
    AdVideoPlaybackFailures: metricKeys.AdEndedPlays,
    AdVideoPlaybackFailuresPercentage: metricKeys.AdEndedPlays,
    AdVideoStartFailures: metricKeys.AdAttempts,
    AdVideoStartFailuresPercentage: metricKeys.AdAttempts,
    AdVideoStartTime: metricKeys.AdPlays,
    AdMinutesPlayedPerUniqueDevice: metricKeys.AdAttempts,
    AdCompletedCreativePlays: metricKeys.AdPlays,
    AdUniqueDevices: metricKeys.AdAttempts,
  },
  AI: {
    AverageBitrate: metricKeys.Plays,
    AdSlateDurationPct: metricKeys.Plays,
    AdSlatePlaysPct: metricKeys.Plays,
    EndedPlaysPerUniqueDevice: metricKeys.Plays,
    AdCompletedCreativePlays: metricKeys.Plays,
    AdsNotStartedPct: metricKeys.Attempts,
    AdsNotStarted: metricKeys.Attempts,
    AdsWithErrorsPct: metricKeys.Attempts,
    AdsWithErrors: metricKeys.Attempts,
    VideoStartFailures: metricKeys.Attempts,
    VideoStartFailuresPercentage: metricKeys.Attempts,
    ExitBeforeVideoStarts: metricKeys.Attempts,
    ExitBeforeVideoStartsPercentage: metricKeys.Attempts,
    RebufferingRatio: metricKeys.Plays,
    ConnectionInducedRebufferingRatio: metricKeys.Plays,
    VideoPlaybackFailures: metricKeys.EndedPlays,
    VideoPlaybackFailuresPercentage: metricKeys.EndedPlays,
    VideoStartTime: metricKeys.Plays,
    VideoRestartTime: metricKeys.EndedPlays,
    Bitrate: metricKeys.Plays,
    Framerate: metricKeys.Plays,
    PlaysPercentage: metricKeys.Attempts,
    UniqueDevices: metricKeys.Attempts,
    MinutesPlayedPerUniqueDevice: metricKeys.Attempts,
  },
  ODP: {},
  ECO_SERVER: {},
};

export default METRICS_MAPPING[CURRENT_PRODUCT_MODE];
